import React from "react";
import Table from "./Table/index";

export default function Subscription() {
  return (
    <div>
      <Table />
    </div>
  );
}
